import { SVGProps, Ref, forwardRef } from 'react'
interface SVGRProps {
  className?: string
  title?: string
  titleId?: string
}
const ReconnectIcon = (
  { className, title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 46 45"
    ref={ref}
    aria-labelledby={titleId}
    className={className}
    {...props}
  >
    {title ?
      <title id={titleId}>{title}</title>
    : null}
    <circle cx={23} cy={22.5} r={22.5} fill="#242838" />
    <path
      fill="white"
      d="M19.75 17.69h-3.485a4.822 4.822 0 0 0-4.655 3.574H6.908v2.502h4.702a4.823 4.823 0 0 0 4.655 3.574h3.485v-2.357h2.627v-4.937H19.75V17.69ZM33.472 21.264a4.822 4.822 0 0 0-4.655-3.575h-3.485v9.65h3.485a4.822 4.822 0 0 0 4.655-3.573h4.702v-2.502h-4.702Z"
    />
  </svg>
)
const ForwardRef = forwardRef(ReconnectIcon)
export default ForwardRef
